<div style="min-height:400px; display: flex; align-items: center;justify-content: center;">
    <div style="text-align: center;">
        <div class="flex justify-center">
            <img src="/silone/silone_notfound.png" style="height: 100px;"/>
          </div>
        <div style="font-size: xx-large; margin-bottom: 15px;">
            {{_common.user_notfound}}
        </div>
        <!-- <div>
            {{_common.notfound_exp}}
        </div> -->
        <!-- <div style="margin-top: 20px; cursor: pointer;" class="theme_color">
            <a [href]="realPath(account.context,'')">

                {{_common.backhome}}
            </a>
        </div> -->
    </div>


</div>
